module.exports = __webpack_public_path__ + "static/media/WhatsApp.d30c94e1.svg";